import React, {useEffect, useState} from "react";
import {toCapitalize} from "../utils";
import {Filter} from "../Filter";

export default function CriteriaFilter({
                                                 statusData,
                                                 filteredData,
                                                 expanded,
                                                 onExpandClick,
                                                 onStatusUpdate,
                                                 name
                                             }) {
    const [statusList, setStatusList] = useState([]);

    const handleStatusChange = (event) => {
        const updatedList = statusList.map(list => {
            if (list.name === event.target.name) {
                list.checked = event.target.checked
            }
            return list
        })
        onStatusUpdate(updatedList)
        setStatusList(updatedList)
        if(name === "Criteria Status"){
            sessionStorage.setItem("selectedStatus", JSON.stringify(updatedList));
        }else if(name === "Category"){
            sessionStorage.setItem("selectedCategory", JSON.stringify(updatedList));
        }else if(name === "SubCategory"){
            sessionStorage.setItem("selectedSubcategory", JSON.stringify(updatedList));
        }
    };

    useEffect(() => {
        const list = statusData.map(item => {
            return filteredData.includes(item) ? {
                name: item,
                label: item && toCapitalize(item),
                checked: true
            } : {name: item, label: item && toCapitalize(item), checked: false}
        })

        setStatusList(list)
    }, [statusData, filteredData]);

    return (
        <Filter expanded={expanded} onChange={onExpandClick} statusList={statusList}
                onFilterUpdate={handleStatusChange} name={name}/>
    );
}
